import React from 'react';

import { IconTypes } from '@eika/icon';
import { LinkPanel } from '@eika/link-panel';

import type { AvtalegiroAgreement } from '../../generated-types';
import { paymentTrackIDs } from '../../utils/gtm/trackIDs/payment';

import './AvtaleGiroItem.scss';

interface Props {
    avtalegiro: AvtalegiroAgreement;
    onClick?: () => void;
}

const AvtaleGiroItem: React.FC<Props> = ({ avtalegiro, onClick }) => {
    return (
        <li className="avtalegiro-list__wrapper">
            <LinkPanel
                title={avtalegiro.to}
                onClick={onClick}
                data-track-id={paymentTrackIDs.avtalegiro.agreement}
                datat-track-linkname="avtalegiro-agreement"
                data-testid={String(avtalegiro.id)}
                icon={IconTypes.PENN_24}
            />
        </li>
    );
};

export default AvtaleGiroItem;
